export default {"src":"/_next/static/media/B-Corp.f0089a35.svg","height":82,"width":49};